import { Input } from 'antd-mobile';
import { withNativeElementWrap } from '../../utils/hoc';
export default withNativeElementWrap(Input, ['clear']);
